export const vatCodeLineFrag = `
    id
    type
    entryType
    percentage
    accountId
    account {
        id
        name
    }
`;
